module.exports = __webpack_public_path__ + "static/chosun2-0fa90978a84184891da49ac6cd51745c.png";